import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ variables, palette }) => ({
  marker: {
    transform: 'translateX(-50%)',
    margin: `${variables?.spacingA} ${variables?.spacingNone} ${variables?.spacingNone}`,
    borderRadius: '100px',
    '&.order-status-IN_DELIVERY': {
      backgroundColor: palette?.jet?.supportInfo,
    },
    '&.order-status-ASSIGNED': {
      backgroundColor: palette?.jet?.contentBrand,
    },
    '&.order-status-UNASSIGNED': {
      backgroundColor: palette?.jet?.supportError,
    },
    '&.order-status-DELIVERED': {
      backgroundColor: palette?.jet?.contentBrand,
    },
    '&.order-status-ASSIGNED_TO_NEXT_POOL': {
      backgroundColor: palette?.jet?.contentBrand,
    },
  },
}));

export default styles;
